import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DateFilterService } from './service/date-filter.service';

@Component({
    selector: 'app-date-filter',
    templateUrl: './date-filter.component.html',
    styleUrls: ['./date-filter.component.css'],
    standalone: false
})
export class DateFilterComponent implements OnInit, OnDestroy {
  formGroup: FormGroup;
  formSubscription: Subscription;
  filterState: any;

  constructor(
    private dateFilter: DateFilterService,
    protected fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.filterState = this.dateFilter.getValue();
    this.createForm();
    this.formSubscription = this.formGroup.valueChanges.subscribe(() => {
      if (this.formGroup.valid && this.formGroup.value != this.filterState) {
        this.filterState = this.formGroup.value;
        this.dateFilter.setFilter({
          dateType: this.formGroup.value.dateType,
          startDate: this.formGroup.value.startDate,
          endDate: this.formGroup.value.endDate,
        });
      }
    });
  }

  createForm() {
    this.formGroup = this.fb.group({
      startDate: ['', Validators.required],
      endDate: ['', Validators.required],
      dateType: ['', Validators.required],
    });

    this.formGroup.controls['startDate'].setValue(this.filterState.startDate);
    this.formGroup.controls['endDate'].setValue(this.filterState.endDate);
    this.formGroup.controls['dateType'].setValue(this.filterState.dateType);
  }

  ngOnDestroy(): void {
    this.formSubscription.unsubscribe();
  }
}
